import React, { useContext } from 'react';

import ToggleButton from '@material-ui/lab/ToggleButton/ToggleButton';
import Brightness4OutlinedIcon from '@material-ui/icons/Brightness4Outlined';
import { makeStyles } from '@material-ui/core';
import { ThemeContext } from './themes/ThemeContext';

const useStyles = makeStyles(theme => ({
  root: {
    '&.MuiToggleButton-root': {
      border: 'none',
      color: 'white',
      '&:hover': {
        backgroundColor: 'transparent',
        opacity: 0.7,

        textDecoration: 'none',
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        color: '#333',
      },
    },
  },
}));

const DarkModeButton = () => {
  const [selected, setSelected] = React.useState(false);
  const classes = useStyles();
  const { changeTheme } = useContext(ThemeContext);
  const handleChangeTheme = () => {
    changeTheme();
  };

  return (
    <ToggleButton
      classes={{
        root: classes.root,
      }}
      value="check"
      selected={selected}
      onChange={() => {
        setSelected(!selected);
      }}
      onClick={handleChangeTheme}
      disableRipple
    >
      <Brightness4OutlinedIcon fontSize="large" />
    </ToggleButton>
  );
};

export default DarkModeButton;
